import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Table, {SetRowsPerPage} from '@pluto/table';
import {
    MediaOrderValidationItem,
    OnModalTrigger,
} from '../MediaOrdersTypes';

interface MediaOrderImportValidationsProps {
    handleClose: OnModalTrigger;
    validations: MediaOrderValidationItem[];
    open: boolean;
    rowsPerPage: number;
    setRowsPerPage: SetRowsPerPage;
}

export default function MediaOrderImportValidations(props: MediaOrderImportValidationsProps) {
    const {
        validations,
        handleClose,
        open,
        rowsPerPage,
        setRowsPerPage,
    } = props;
    const tableColumns = [{
        dataKey: 'cell',
        title: 'Col',
    }, {
        dataKey: 'row',
        title: 'Row',
    }, {
        dataKey: 'message',
        title: 'Failure reason(s)',
    }];
    
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="paper"
            className="media-order-import__validations"
        >
            <DialogTitle>
                Media order import failed
            </DialogTitle>
            <DialogContent dividers>
                <Table
                    data={validations}
                    columns={tableColumns}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
